import React from 'react';
import { Row, Col, Card, Badge, UncontrolledTooltip } from 'reactstrap';
import "../assets/scss/SeriesGrid.scss"; // Reusing SeriesGrid styles for consistency

// Assets - Reusing same assets
import btdiggIcon from "../assets/img/btdigg.png";
import googleIcon from "../assets/img/google.jpg";

const MoviesGrid = ({
    movies,
    onDelete,
    onYouTubeClick
}) => {

    if (!movies || movies.length === 0) {
        return (
            <div className="text-center py-5">
                <i className="bi bi-film display-1 text-muted opacity-25 mb-3"></i>
                <h4 className="text-muted fw-light">No tens pel·lícules en la llista.</h4>
                <p className="text-muted small">Afegeix-ne una des de "Novetats".</p>
            </div>
        );
    }

    return (
        <Row>
            {movies.map((movie) => {
                // Determine Genre Color - Reusing logic
                const genreClass = movie.genero 
                    ? `genre-${movie.genero.toLowerCase().replace(/[àèéíòóú]/g, (m) => ({à:'a',è:'e',é:'e',í:'i',ò:'o',ó:'o',ú:'u'}[m])).replace(/\s+/g, '-').replace(/ç/g, 'c')}`
                    : '';

                return (
                <Col key={movie._id} xs={12} sm={6} lg={4} xl={3} className="mb-4">
                    <Card className="series-grid-card h-100">
                        
                        {/* 1. Image Container */}
                        <div className="image-container">
                            <img 
                                src={movie.image || "https://via.placeholder.com/300x450?text=No+Poster"} 
                                alt={movie.nom}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                            />
                        </div>

                        {/* 2. Top Badges */}
                        <div className="status-badges">
                             {/* Future: Watched/Unwatched badge */}
                        </div>
                        {movie.definicio && (
                            <div className="quality-badge">
                                <Badge pill>{movie.definicio.replace(/[\[\]]/g, '')}</Badge>
                            </div>
                        )}
                        {movie.genero && (
                            <div className="genre-badge">
                                <Badge pill className={genreClass}>
                                    {movie.genero}
                                </Badge>
                            </div>
                        )}

                        {/* 3. Bottom Info Content */}
                        <div className="serie-info-content">
                            <h5 className="serie-title" title={movie.nom}>{movie.nom}</h5>
                            
                            <div className="serie-meta">
                                <span>{movie.year || '----'}</span>
                                {movie.runtime > 0 && (
                                    <span className="ms-2">
                                        <i className="bi bi-clock"></i> {Math.floor(movie.runtime / 60)}h {movie.runtime % 60}m
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* 4. Hover Actions Overlay */}
                        <div className="serie-overlay-actions">
                            <div className="action-btn-group gap-2"> {/* Increased gap for better spacing */}
                                
                                {/* 1. BTDigg Search */}
                                <a 
                                    href={`https://btdig.com/search?order=2&q=${encodeURIComponent(`${(movie.nom || '').normalize("NFD").replace(/[\u0300-\u036f]/g, "")} [Bluray][Esp]`)}`} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="btn-circle btn-light-soft"
                                    title="Buscar en BTDigg"
                                >
                                    <img src={btdiggIcon} alt="BT" height="18" style={{borderRadius:'50%'}}/>
                                </a>

                                {/* 2. Google Search */}
                                <a 
                                    href={`https://www.google.com/search?q=${encodeURIComponent(`${movie.nom || ''} pelicula`)}`} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="btn-circle btn-light-soft"
                                    title="Buscar en Google"
                                >
                                    <img src={googleIcon} alt="G" height="18" style={{borderRadius:'50%'}}/>
                                </a>

                                {/* 3. YouTube Search / PopUp */}
                                {onYouTubeClick ? (
                                     <button
                                        className="btn-circle btn-danger-soft border-0"
                                        title="Veure Videos (Trailers)"
                                        onClick={() => onYouTubeClick(movie)}
                                     >
                                         <i className="bi bi-youtube"></i>
                                     </button>
                                ) : (
                                    <a 
                                        href={`https://www.youtube.com/results?search_query=${encodeURIComponent(`${movie.nom || ''} trailer español`)}`} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="btn-circle btn-danger-soft"
                                        title="Buscar en YouTube"
                                    >
                                        <i className="bi bi-youtube"></i>
                                    </a>
                                )}

                                {/* 4. Delete Button */}
                                <span> {/* Wrapper for tooltip target */}
                                    <button 
                                        id={`btn-delete-movie-${movie._id}`}
                                        className="btn-circle btn-danger-soft" 
                                        onClick={() => onDelete(movie._id)}
                                    >
                                        <i className="bi bi-trash3-fill"></i>
                                    </button>
                                </span>
                                <UncontrolledTooltip 
                                    placement="top" 
                                    target={`btn-delete-movie-${movie._id}`}
                                >
                                    Eliminar de la llista
                                </UncontrolledTooltip>
                            </div>
                        </div>

                    </Card>
                </Col>
            )})}
        </Row>
    );
};

export default MoviesGrid;
